import LivestreamCalendar from "../../components/LiveStreams/Calendar/LivestreamCalendar";

const CalendarWidgetPage = () => {
  return (
    <div className="max-w-6xl mx-auto py-4">
      <LivestreamCalendar isWidget={true} />
    </div>
  );
};

export default CalendarWidgetPage;
